import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { Bell, Check, Clock, LucideAngularModule, Menu } from 'lucide-angular';
import { NotificationItem } from '../../models/layout.models';

@Component({
  selector: 'app-header',
  imports: [LucideAngularModule],
  templateUrl: './header.html',
  styleUrl: './header.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Header {
  readonly notifications = input.required<NotificationItem[]>();
  readonly markAsRead = output<string>();

  readonly showNotifications = signal(false);

  readonly icons = {
    bell: Bell,
    check: Check,
    clock: Clock,
    menu: Menu,
  };

  readonly unreadCount = computed(
    () => this.notifications().filter((notification) => !notification.isRead).length,
  );

  private readonly timeFormatter = new Intl.DateTimeFormat('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  });

  toggleNotifications(): void {
    this.showNotifications.update((value) => !value);
  }

  closeNotifications(): void {
    this.showNotifications.set(false);
  }

  handleMarkAsRead(id: string): void {
    this.markAsRead.emit(id);
  }

  formatTime(date: string): string {
    return this.timeFormatter.format(new Date(date));
  }
}
